import { Navigate } from 'react-router-dom';
import { useAuthContext } from '../../hooks/UseAuthContext';
import { useIsAdmin } from '../../hooks/useIsAdmin';
import Loader from '../Loader/Loader';

/**
 * Admin-only routes — requires login + MongoDB user.status === 'admin'.
 */
export default function AdminRoute({ children }) {
  const { user } = useAuthContext();
  const { isAdmin, loading } = useIsAdmin();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (loading) {
    return <Loader />;
  }

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return children;
}
